module.exports = __webpack_public_path__ + "img/teo0.8079dc00.jpg";